import React from "react";
import MdsRow from "../utilities/MdsRow";
import ProjectCard from "./ProjectCard";
import MdsCol from "../utilities/MdsCol";
import MotionSingle from "../utilities/Motion/MotionSingle";

const ProjectsGrid = ({
  projects = null,
  bigCardInterval = 3,
  grayBgCards = true,
  lang,
}) => {
  const Translations = {
    no_projects: {
      "el-gr": "Δεν υπάρχουν project",
      "en-us": "No projects found",
      "de-de": "Keine Projekte gefunden",
    },
  };

  return (
    <MdsRow>
      {projects && projects.length > 0 ? (
        projects.map((project, index) => {
          const isBigCard = (index + 1) % bigCardInterval === 0;
          return (
            <MdsCol key={project?.data?.title || index} sm={isBigCard ? 12 : 6}>
              <MotionSingle delay={index % 2 ? 0.1 : 0} offsetY="50%">
                <ProjectCard
                  project={project}
                  isBig={isBigCard}
                  grayBg={grayBgCards}
                />
              </MotionSingle>
            </MdsCol>
          );
        })
      ) : (
        <MdsCol>
          {Translations.no_projects[lang] ||
            Translations.no_projects["en-us"] ||
            Translations.no_projects["de-de"]}
        </MdsCol>
      )}
    </MdsRow>
  );
};

export default ProjectsGrid;
